var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1.25C6.51065 1.25 1.25 6.51065 1.25 13C1.25 19.4893 6.51065 24.75 13 24.75C19.4893 24.75 24.75 19.4893 24.75 13C24.75 6.51065 19.4893 1.25 13 1.25ZM0.75 13C0.75 6.23451 6.23451 0.75 13 0.75C19.7655 0.75 25.25 6.23451 25.25 13C25.25 19.7655 19.7655 25.25 13 25.25C6.23451 25.25 0.75 19.7655 0.75 13Z",
    fill: "#6429CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0829 7.11716C16.2391 7.27337 16.2391 7.52663 16.0829 7.68284L10.7657 13L16.0829 18.3172C16.2391 18.4734 16.2391 18.7266 16.0829 18.8828C15.9267 19.0391 15.6734 19.0391 15.5172 18.8828L9.91721 13.2828C9.761 13.1266 9.761 12.8734 9.91721 12.7172L15.5172 7.11716C15.6734 6.96095 15.9267 6.96095 16.0829 7.11716Z",
    fill: "#330072"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftCircle);
export default __webpack_public_path__ + "static/media/arrow-left-circle.4c4098bdb41f4199cbc2c946692220f6.svg";
export { ForwardRef as ReactComponent };